module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Polygon-b93f99914ddbc72c70d2b16e943da013.svg";